import styles from '../styles/survey.module.css';
import FeaturesCarousell from './FeaturesCarousell';


const SurveyFeatures = ({ featuresData, familyLink }) => {

    return (
        <div className={styles.mainFeatureContainer}>
            <h2 className={styles.header}>Our features, especally<br />for you</h2>
            <FeaturesCarousell featuresArray={featuresData} />
        </div>
    )
}

export default SurveyFeatures